import { Mail, MapPin, Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#272B36] bg-[#090A0C]">
      <div className="mx-auto max-w-7xl px-6 pb-10 pt-16 lg:px-10">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center bg-[#E65100] font-display text-xl font-bold text-white">
                F
              </span>
              <span className="font-display text-xl font-bold uppercase tracking-wide text-[#F8FAFC]">
                Forte Servizii SRLS
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#64748B]">{f.blurb}</p>
          </div>
          <div>
            <p className="font-mono-tech text-[11px] font-bold uppercase tracking-[0.25em] text-[#64748B]">
              {f.navTitle}
            </p>
            <nav className="mt-4 flex flex-col gap-3">
              {t.nav.links.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id.slice(1)}`}
                  onClick={() => scrollToId(l.id)}
                  className="w-fit text-sm text-[#94A3B8] transition-colors hover:text-[#F97316]"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>
          <div>
            <p className="font-mono-tech text-[11px] font-bold uppercase tracking-[0.25em] text-[#64748B]">
              {f.contactTitle}
            </p>
            <div className="mt-4 flex flex-col gap-3">
              <p
                data-testid="footer-address"
                className="flex items-start gap-2 text-sm text-[#94A3B8]"
              >
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#F97316]" />
                Via Fabio Filzi 6/A, 37047 San Bonifacio (VR)
              </p>
              <a
                data-testid="footer-email-link"
                href="mailto:Forteservizii2000@gmail.com"
                className="flex w-fit items-center gap-2 break-all text-sm text-[#94A3B8] transition-colors hover:text-[#F97316]"
              >
                <Mail className="h-4 w-4 shrink-0 text-[#F97316]" />
                Forteservizii2000@gmail.com
              </a>
              <a
                data-testid="footer-phone-link"
                href="tel:+393931961669"
                className="flex w-fit items-center gap-2 text-sm text-[#94A3B8] transition-colors hover:text-[#F97316]"
              >
                <Phone className="h-4 w-4 shrink-0 text-[#F97316]" />
                +39 393 196 1669
              </a>
            </div>
          </div>
        </div>

        <div
          className="pointer-events-none mt-16 select-none text-center font-display text-[18vw] font-bold uppercase leading-[0.8] text-outline md:text-[13vw]"
          aria-hidden="true"
        >
          Forte
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-[#272B36] pt-6 sm:flex-row">
          <p data-testid="footer-legal-line" className="text-xs text-[#64748B]">
            © {new Date().getFullYear()} Forte Servizii SRLS · P.IVA 05072040230 · Via Fabio Filzi
            6/A, 37047 San Bonifacio (VR) · {f.rights}
          </p>
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#64748B]">
            {f.standards}
          </p>
        </div>
      </div>
    </footer>
  );
}
